import React, { useState, useEffect } from "react";
import { FaBars, FaTimes, FaPhone, FaSms, FaWhatsapp } from "react-icons/fa";
import { Link } from "react-router-dom";
import lincolnMKT from "../assets/images/Lincoln MKT.png";
import "../styles/MobileHeader.css";

const MobileHeader = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  // Posición fija para los botones
  const floatingBottom = "20px";

  const handleMenuToggle = () => {
    setMenuOpen(!menuOpen);
  };

  const navItems = [
    { label: "Welcome", path: "/" },
    { label: "Luxury Fleet", path: "/fleet" },
    { label: "Chauffeur Booking", path: "/reservations" },
    { label: "Client FAQs", path: "/faq" },
    { label: "VIP Assistance", path: "/contact" }
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <style>
        {`
          @keyframes blink {
            0% { opacity: 1; }
            50% { opacity: 0.4; }
            100% { opacity: 1; }
          }
          @keyframes fadeUp {
            0% { opacity: 0; transform: translateY(20px); }
            100% { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>

      <header
        className={`mobileHeader ${isSticky ? "sticky" : ""}`}
        style={
          isSticky
            ? {
                borderBottom: "1px solid #0d2b3e",
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                zIndex: 1100,
                backgroundColor: "#fff",
                padding: "10px 0",
              }
            : { borderBottom: "1px solid #0d2b3e" }
        }
      >
        <div className="menuIconContainer" onClick={handleMenuToggle}>
          {menuOpen ? (
            <FaTimes className="closeIcon" />
          ) : (
            <FaBars className="menuIcon" />
          )}
        </div>

        <div className="logoSection">
          <img src={lincolnMKT} alt="Lincoln MKT" className="carImage carImage3D" />
          <div className="textContainer">
            <h1 className="logoText">Jet Black</h1>
            <p className="logoSubText">Limo Service</p>
          </div>
        </div>

        {menuOpen && (
          <nav className="mobileNav floatingNav">
            {navItems.map((item, index) => (
              <Link key={index} to={item.path} onClick={handleMenuToggle} className="navLink">
                {item.label}
              </Link>
            ))}
          </nav>
        )}
      </header>

      {/* Botones flotantes siempre visibles */}
      <div
        className="floatingButtons"
        style={{
          position: "fixed",
          right: "1.5cm", // Ahora a 1.5 cm desde el borde derecho
          bottom: floatingBottom,
          display: "flex",
          flexDirection: "column",
          gap: "15px",
          zIndex: 1000,
          animation: "fadeUp 0.6s ease-out",
        }}
      >
        {/* Botón para Llamada (teléfono) */}
        <a
          href="tel:+19149628444"
          style={{
            ...baseButtonStyle,
            backgroundColor: "#0d2b3e",
            boxShadow:
              "0 16px 32px rgba(13,43,62,1), 0 12px 24px rgba(13,43,62,0.8)",
          }}
          onMouseEnter={(e) =>
            Object.assign(e.currentTarget.style, { transform: "rotate(5deg)" })
          }
          onMouseLeave={(e) =>
            Object.assign(e.currentTarget.style, { transform: "rotate(0deg)" })
          }
        >
          <FaPhone size={24} />
        </a>
        {/* Botón para SMS */}
        <a
          href="sms:+19149628444"
          style={{
            ...baseButtonStyle,
            backgroundColor: "#000000",
            boxShadow:
              "0 16px 32px rgba(0,0,0,0.9), 0 12px 24px rgba(0,0,0,0.7)",
          }}
          onMouseEnter={(e) =>
            Object.assign(e.currentTarget.style, { transform: "rotate(5deg)" })
          }
          onMouseLeave={(e) =>
            Object.assign(e.currentTarget.style, { transform: "rotate(0deg)" })
          }
        >
          <FaSms size={24} />
        </a>
        {/* Botón para WhatsApp */}
        <a
          href="https://wa.me/19149628444"
          style={{
            ...baseButtonStyle,
            backgroundColor: "#25D366",
            boxShadow:
              "0 16px 32px rgba(37,211,102,0.9), 0 12px 24px rgba(37,211,102,0.7)",
          }}
          onMouseEnter={(e) =>
            Object.assign(e.currentTarget.style, { transform: "rotate(5deg)" })
          }
          onMouseLeave={(e) =>
            Object.assign(e.currentTarget.style, { transform: "rotate(0deg)" })
          }
        >
          <FaWhatsapp size={24} />
        </a>
      </div>
    </>
  );
};

const baseButtonStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "60px",
  height: "60px",
  borderRadius: "50%", // Botones redondos
  color: "#fff",
  textDecoration: "none",
  boxShadow: "0 16px 32px rgba(13,43,62,1), 0 12px 24px rgba(13,43,62,0.8)",
  animation: "blink 1s infinite",
  transition: "transform 0.3s ease, box-shadow 0.3s ease",
};

export default MobileHeader;
